<template>
  <!-- 递归子菜单 -->
  <template v-for="item in menus" :key="item.id">
    <!-- 判断有无子组件，有的为submenu，且需要继续调用本组件 -->
    <el-sub-menu v-if="item.children.length>0" :index="''+item.id">
      <template #title><i class="iconfont" :class="item.icon"></i><span>{{ item.name }}</span></template>
      <!-- 调用子组件，传入需要递归的数据 -->
      <sideMenu :menus="item.children"></sideMenu>
    </el-sub-menu>
    <!-- 没有子组件，直接渲染最后一级菜单 -->
    <el-menu-item v-else :index="item.rule">
      <i class="iconfont" :class="item.icon"></i><template #title><span>{{ item.name }}</span></template>
    </el-menu-item>
  </template>
</template>
<script>
export default {
  name: 'sideMenu',
  props: {
    menus: {
      type: Array,
      default() {
        return [];
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.iconfont{font-size: 20px;margin-right: 10px;}
</style>
